export default "__VITE_ASSET__CGc9gCGZ__"